/**
 * LD.CLPBP.Public.Service
 * No descripton provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
import * as models from './models';

export interface LDCLPBPPublicApiModelsBorrowersUpdateBorrowerRequest {
    

    deviceInfo?: models.LDCLPBPPublicApiModelsCommonDeviceInfo;

    guid?: string;

    emailAddress?: string;

    firstName?: string;

    nameSuffix?: string;

    lastName?: string;

    middleInitial?: string;

    address?: models.LDCLPBPPublicApiModelsCommonAddress;

    phoneNumber?: string;

    dateOfBirth?: Date;

    employmentStatus?: LDCLPBPPublicApiModelsBorrowersUpdateBorrowerRequest.EmploymentStatusEnum;

    incomeTypes?: Array<LDCLPBPPublicApiModelsBorrowersUpdateBorrowerRequest.IncomeTypesEnum>;

    currentEmployer?: models.LDCLPBPPublicApiModelsBorrowersEmploymentInfo;

    occupancyStatus?: LDCLPBPPublicApiModelsBorrowersUpdateBorrowerRequest.OccupancyStatusEnum;

    homeMonthlyPayment?: number;

    annualIncome?: number;

    creditScoreEstimate?: LDCLPBPPublicApiModelsBorrowersUpdateBorrowerRequest.CreditScoreEstimateEnum;

    isMilitary?: boolean;

    isActiveDuty?: boolean;

    borrowerSource?: string;
}
export namespace LDCLPBPPublicApiModelsBorrowersUpdateBorrowerRequest {

    export enum EmploymentStatusEnum { 
        Employed = <any> 'Employed',
        SelfEmployed = <any> 'SelfEmployed',
        Military = <any> 'Military',
        Unemployed = <any> 'Unemployed',
        Retired = <any> 'Retired',
        Other = <any> 'Other',
    }

    export enum IncomeTypesEnum { 
        Rental = <any> 'Rental',
        SocialSecurity = <any> 'SocialSecurity',
        PensionOrAnnuity = <any> 'PensionOrAnnuity',
        IRA = <any> 'IRA',
        InterestOrDividends = <any> 'InterestOrDividends',
        Alimony = <any> 'Alimony',
        ChildSupport = <any> 'ChildSupport',
        Disability = <any> 'Disability',
    }

    export enum OccupancyStatusEnum { 
        FullyOwn = <any> 'FullyOwn',
        Mortgage = <any> 'Mortgage',
        Other = <any> 'Other',
        Own = <any> 'Own',
        Rent = <any> 'Rent',
        NoRentOrHousingPayment = <any> 'NoRentOrHousingPayment',
    }

    export enum CreditScoreEstimateEnum { 
        Excellent = <any> 'Excellent',
        Good = <any> 'Good',
        Fair = <any> 'Fair',
        Poor = <any> 'Poor',
    }
}
